<template>
  <span :class="$style.levelBadge"> Lv.{{ level }} </span>
</template>

<script>
export default {
  name: "UserLevelMini",
  props: {
    level: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    // console.log("UserLevelMini 마운트됨 - 레벨:", this.level);
  },
};
</script>

<style module>
.levelBadge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  color: white;
  background: #9ca3af;
  font-family: "NanumSquareRoundB", sans-serif;
  margin-left: 4px;
  vertical-align: middle;
  line-height: 13px;
}
</style>
